import { client } from './client'
import { fastly } from './fastly'
import { normalizeCountriesResponse } from './normalize'

const fetchRates = async (rateSearchRequest) => {
  try {
    let resource = `/api/v1/rates/${rateSearchRequest.geolocation}/${rateSearchRequest.locale}/${rateSearchRequest.currency}/${rateSearchRequest.toCountry}/`
    let response = await client.get(resource)
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchCountries = async (locale) => {
  try {
    let resource = `/api/countries/${locale}/`
    let response = await fastly.get(resource)
    return normalizeCountriesResponse(response.data)
  } catch (error) {
    throw error
  }
}

const changeUserPassword = async (newPassword, oldPassword) => {
  try {
    let resource = `/api/v1/user/password/`
    let response = await client.put(
      resource,
      {
        newPassword: newPassword,
        oldPassword: oldPassword
      }
    )

    return response
  } catch (error) {
    throw error
  }
}

export {
  fetchRates,
  fetchCountries,
  changeUserPassword
}



// WEBPACK FOOTER //
// ./src/api/web/index.js